import React from 'react'
import Field from './Field.js'

export default props => {

    return <Field type="textarea" name="description" rows="3" pattern=".{3,256}"
        label="Опис" placeholder="Опис" title="Від 3 до 256 символів"
        {...props} />
}